import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDatepicker, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { Utility } from 'src/app/shared/utility/utility';
import { SrcReservationDateSelService } from '../src-reservation-date-sel/src-reservation-date-sel.service';
import { MstUserDTO } from 'src/app/models/MstUser';
import { RsvDateTimeDTO } from 'src/app/models/RsvDateTime';
import { MstExaminationFrameDTO } from 'src/app/models/MstExaminationFrameDTO';
import { ScreenMode } from 'src/app/shared/screen-mode';
import { IAppState } from 'src/app/store/states/app.state';
import { Store } from '@ngrx/store';
import { GetIMstHTOrg } from 'src/app/store/actions/mstHTOrg.action';
import { DeactivateGuard } from 'src/app/can-deactivate-guard.service';
import { DialogResult } from 'src/app/shared/dialog-modal/dialog-types';
import { Observable } from 'rxjs';
/* 20231006 add #19525 start */ 
import { CommonService } from './../../../../services/common.service';
/* 20231006 add #19525 end */ 

@Component({
  selector: 'app-src-reservation-date-sel',
  templateUrl: './src-reservation-date-sel.component.html',
  styleUrls: ['./src-reservation-date-sel.component.scss']
})
export class SrcReservationDateSelComponent implements OnInit, DeactivateGuard {
  // Setup Calendar
  isDisabled: any;
  startDate: any;
  endDate: any;
  dateCustomClasses: any[] = [];
  disabledDates: NgbDateStruct[] = [];
  notBusinessDay = '2';
  disabledPrev = true;
  disabledNext = false;
  objRsvDateTime = new RsvDateTimeDTO();
  lstExaminationFrame : MstExaminationFrameDTO[];
  minDate: any;
  typeMode = 1; // 1: add ; 2: edit; 3: e dit confirm
  @ViewChild(NgbDatepicker, { static: true }) datepicker: NgbDatepicker;
  // End Calendar
  objUser = new MstUserDTO();
  listReservationSelect: any[] = [];
  HTOrgCode: any;
  dataReservation: any;
  /*20240412 add #21672 start */
  // isClick: false;
  /*20240412 add #21672 end */
  RsvDate: any;
  RsvDateParam: any;
  RsvNumParam: any;
  disableAllDay : any = false;
  disableDayOddOrEven: any = '3'; //  3: get odd and even , 1:odd number, 2: even number
  isLoadDataLocal = false;
  isBack0305 = false;
  isRedirect = false;
  isRedirecting = false;
  strDate: any;
  /* 20241015 #20724 add start */
  genderConflict = false;
  /* 20241015 #20724 add end */
  /* 20241129 #23420 add start */
  ListNationalHoliday: any[] = [];
  /* 20241129 #23420 add end */
  constructor(
    private router: Router,
    public util: Utility,
    private loadingSrv: LoadingService,
    private dialogModalService: DialogModalService,
    public trans: TranslateService,
    private reservationDateSelService: SrcReservationDateSelService,
    private calendar: NgbCalendar,
    private routeActived: ActivatedRoute,
    private store: Store<IAppState>,
    /* 20231006 add #19525 start */ 
    private common: CommonService,
    /* 20231006 add #19525 end */ 
  ) { }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    window.history.forward()
  }
  ngOnInit(): void {
    this.util.resetZoomBrowser();
    this.preventButtonBackBrowser()
    const strHTOrgCode = sessionStorage.getItem('HTOrgCode');
    const dataLocal = sessionStorage.getItem('DataReservation');
    if (!this.util.isNullOrEmpty(strHTOrgCode) && !this.util.isNullOrEmpty(dataLocal)) {
      this.HTOrgCode = strHTOrgCode;
      this.dataReservation = JSON.parse(dataLocal);
      this.typeMode = 1;
      const strMode = this.routeActived.snapshot.queryParams.mode;
      const strBack0305 = this.routeActived.snapshot.queryParams.back;
      /* 20241015 #20724 add start */
      this.genderConflict = this.util.isNullOrEmpty(this.routeActived.snapshot.queryParams.genderConflict) ? false : this.routeActived.snapshot.queryParams.genderConflict; 
      /* 20241015 #20724 add end */
      /*20240412 add #21672 start */
      /*20240510 modify #21672 start */
      // // this.isClick = this.routeActived.snapshot.queryParams.isclick ? this.routeActived.snapshot.queryParams.isclick : false;
      // this.isClick = this.routeActived.snapshot.queryParams.isclick
      // /*20240510 modify #21672 end */
      /*20240412 add #21672 end */
      if (strMode === ScreenMode.Edit && !this.util.isNullOrBlank(this.dataReservation.typeReservation)) {
        this.typeMode = 2;
        if (!this.util.isNullOrBlank(strBack0305)) {
          this.isBack0305 = true;
        }
      } else if (strMode === ScreenMode.Edit && this.util.isNullOrBlank(this.dataReservation.typeReservation)) {
        this.typeMode = 3;
        if (!this.util.isNullOrBlank(strBack0305)) {
          this.isBack0305 = true;
        }
      }
      if (this.util.isNullOrEmpty(this.dataReservation.objUser)
        || this.util.isNullOrEmpty(this.dataReservation.objCourse)
        || (this.typeMode === 2 && this.util.isNullOrEmpty(this.dataReservation.isReservationDetail))
        || (strMode !== ScreenMode.Edit && this.util.isNullOrBlank(this.dataReservation.typeReservation))) {
        this.router.navigateByUrl('404');
        return;
      }
      const objHTOrg = {
        HTOrgCode: null,
        HTOrgName: this.dataReservation.HTOrgName,
      };
      this.store.dispatch(new GetIMstHTOrg(objHTOrg));
      this.objUser = this.dataReservation.objUser;
      this.startDate = moment().toDate();
      this.strDate = this.startDate;
      this.endDate = moment().endOf('month').toDate();
      this.minDate = this.calendar.getToday();
      if (!this.util.isNullOrEmpty(this.dataReservation.objRsvDateTime)) {
        this.objRsvDateTime = this.dataReservation.objRsvDateTime;
        const intYear = parseInt(this.objRsvDateTime.RsvYMD.substring(0, 4), 0);
        const intMonth = parseInt(this.objRsvDateTime.RsvYMD.substring(4, 6), 0);
        const intDay = parseInt(this.objRsvDateTime.RsvYMD.substring(6, 8), 0);
        this.RsvDate = {
          year: intYear,
          month: intMonth,
          day: intDay,
        };
        if (this.typeMode === 3) {
          const dataLocalOld = sessionStorage.getItem('DataReservationOld');
          const dataOld = JSON.parse(dataLocalOld);
          if (!this.util.isNullOrEmpty(dataOld)) {
            this.RsvDateParam = dataOld.RsvDate;
            this.RsvNumParam = dataOld.RsvNum;
          }
        }
        this.datepicker.navigateTo(this.RsvDate);
        if (intYear >= parseInt(moment().format('YYYY'), 0) && intMonth > parseInt(moment().format('MM'), 0)) {
          this.startDate = moment(this.objRsvDateTime.RsvYMD, 'YYYYMMDD').startOf('month').toDate();
          this.disabledPrev = false;
          this.minDate = null;
        }
        this.endDate = moment(this.objRsvDateTime.RsvYMD, 'YYYYMMDD').endOf('month').toDate();
        this.isLoadDataLocal = true;
      }
      this.checkOptionOddOrEven();
      this.getReservationStatus(this.isLoadDataLocal);
      setTimeout(() => {
        this.util.addPerfectScrollBar();
        $('.scrollbar').scrollTop(0);
      }, 100);
    } else {
      this.router.navigateByUrl('404');
    }
  }
  /* 20241129 #23420 add start */
  getListNationalHoliday() {
    const strDefaultLang = this.trans.getDefaultLang();
    const objRequest = {
      StartDate: moment(this.startDate).startOf('year').format('YYYYMMDD'),
      EndDate: moment(this.endDate).endOf('year').format('YYYYMMDD'),
      Locale: strDefaultLang ? strDefaultLang : 'ja',
    };
    this.reservationDateSelService.getNationalHoliday(objRequest).subscribe(data => {
      if (data && data.length > 0) {
        this.ListNationalHoliday = data;
      }
    }, err => {
    });
  }
  /* 20241129 #23420 add end */
  /* 20241129 #23420 add start */
  getNationalHoliday(date) {
    if (this.ListNationalHoliday && this.ListNationalHoliday.length > 0) {
      const day = date.year.toString() + '-' + (date.month > 9 ? date.month.toString() : '0' + date.month.toString())
        + '-' + (date.day > 9 ? date.day.toString() : '0' + date.day.toString());
      const findDate = this.ListNationalHoliday.find(x => x.StartDate === day);
      return findDate ? true : false;
    } else {
      return false;
    }
  }
  /* 20241129 #23420 add end */
  getReservationStatus(isSelect = false) {
    this.loadingSrv.setDisplay(true);
    const objSearch = {
	  // 20241223 modify #19712 start
      // StartDate: moment(this.startDate).format('YYYYMMDD'),
      StartDate: moment(this.endDate).format('YYYYMMDD').substring(0,6) + "01",
      // 20241223 modify #19712 end
      EndDate: moment(this.endDate).format('YYYYMMDD'),
      HTOrgCode: this.HTOrgCode,
      RsvGender: this.objUser.Gender,
      HTCourseCode: this.dataReservation.objCourse?.HTCourseCode,
      CoCode: this.dataReservation.objCourse?.CoCode,
      HTSetItemCode: this.getListHTSetItemCode(),
      DateOfBirth: this.objUser.DateOfBirth
      /* 20241015 #20724 add start */
      ,GenderConflict: this.genderConflict
      /* 20241015 #20724 add end */
      /* 20250318 #24407 add start */
      ,RsvNum: this.objUser.RsvNum
      ,RsvYMD: this.objUser.RsvDate
      ,RsvTime: this.objUser.RsvTime
      /* 20250415 #24407 add start */
      ,EditDateFlag: this.objRsvDateTime.RsvYMD == this.objUser.RsvDate,
      /* 20250415 #24407 add end */
      /* 20250318 #24407 add end */
    };
    /* 20241129 #23420 add start */
    this.getListNationalHoliday();
    /* 20241129 #23420 add end */
    this.reservationDateSelService.searchReservationStatus(objSearch).subscribe(data => {
      if (data) {
        this.disabledDates = [];
        this.lstExaminationFrame = data.MstExaminationFrame;
        this.dateCustomClasses = [];
        if (data.ListBusinessDay && data.ListBusinessDay.length > 0) {

            data.ListReservationDate.forEach((res) => {
             const dayOddEven =  parseInt(res.RsvYMD.substring(6,8),0)
             const valueMonth = parseInt(res.RsvYMD.substring(4, 6), 0);
             const valueYear = parseInt(res.RsvYMD.substring(0, 4), 0);
             const checkAge = this.ageCalculateByTypeOne(objSearch.DateOfBirth,this.dataReservation.objCourse?.AgeCalculateDiv,res.RsvYMD)
                const date = {
                 day: dayOddEven,
                 month: valueMonth,
                 year: valueYear,
               }; // filter for disable odd day
          if(this.disableDayOddOrEven !== OddEvenAgeDiv.Both && !this.util.isNullOrEmpty(this.dataReservation.objCourse)) {
             if(this.disableDayOddOrEven === OddEvenAgeDiv.Odd) {
              if(parseInt(checkAge)%2===0) {
                // 20230915 modify #19712 start
                //this.disabledDates.push(date);
                const objDate = { date: res.RsvYMD, value: 0 };
                this.dateCustomClasses.push(objDate);
                // 20230915 modify #19712 end
                }
              } else {
                if(parseInt(checkAge)%2!==0) {
                // 20230915 modify #19712 start
                //this.disabledDates.push(date);
                const objDate = { date: res.RsvYMD, value: 0 };
                this.dateCustomClasses.push(objDate);
                // 20230915 modify #19712 end
                }
              }
             } else {
              if(this.disableAllDay) {
                // 20230915 modify #19712 start
                //this.disabledDates.push(date);
                const objDate = { date: res.RsvYMD, value: 0 };
                this.dateCustomClasses.push(objDate);
                // 20230915 modify #19712 end
              }
             }
            }
           )
          for (const element of data.ListBusinessDay) {
            const valueMonth = parseInt(element.RsvYearMonth.substring(4, 6), 0);
            const valueYear = parseInt(element.RsvYearMonth.substring(0, 4), 0);
            const keys = Object.keys(element);
            for (const key of keys) {
              if (key.includes('BusinessDay') &&!this.util.isNullOrBlank(element[key])) {
                // 20230915 modify #19712 start
                // if(this.notBusinessDay === element[key]||(moment(element.WebRsvReleaseDate).diff(moment(this.strDate))<=0)==false){
                //   const valueDay = parseInt(key.replace('BusinessDay', ''), 0);
                //   const date = {
                //     day: valueDay,
                //     month: valueMonth,
                //     year: valueYear,
                //   };
                //   this.disabledDates.push(date);
                // }
                /* 20250220 #19712 modify start */
                // const valueDay = parseInt(key.replace('BusinessDay', ''), 0);
                // if(this.notBusinessDay === element[key]){
                //   const date = {
                //     day: valueDay,
                //     month: valueMonth,
                //     year: valueYear,
                //   };
                //   this.disabledDates.push(date);
                // }
                // if((moment(element.WebRsvReleaseDate).diff(moment(this.strDate))<=0)==false){
                //   const objDate = { date: moment(valueYear+valueMonth+valueDay).format('YYYYMMDD'), value: 0 };
                //   this.dateCustomClasses.push(objDate);
                // }
                const valueDay = parseInt(key.replace('BusinessDay', ''), 0);
                if(this.notBusinessDay === element[key]||(moment(element.WebRsvReleaseDate).diff(moment(this.strDate))<=0)==false){
                  const date = {
                    day: valueDay,
                    month: valueMonth,
                    year: valueYear,
                  };
                  this.disabledDates.push(date);
                }
                if((moment(element.WebRsvReleaseDate).diff(moment(this.strDate))<=0)==false){
                  const objDate = { date: moment(valueYear+String(valueMonth).padStart(2, '0')+String(valueDay).padStart(2, '0')).format('YYYYMMDD'), value: 0 };
                  this.dateCustomClasses.push(objDate);
                }
                /* 20250220 #19712 modify end */
                // 20230915 modify #19712 end
              }
            }
          }
        }
        const listDate = [];
        const dateMove = new Date(this.startDate);
        const endDate = new Date(this.endDate);
        const stopDate = new Date(endDate.setDate(endDate.getDate() + 1));
        while (dateMove < stopDate) {
          const strDate = moment(dateMove).format('YYYYMMDD');
          listDate.push(strDate);
          dateMove.setDate(dateMove.getDate() + 1);
        }
        let strDayRegis = null;
        if (moment(this.strDate).format('YYYYMM') === moment().format('YYYYMM') && !this.util.isNullOrBlank(data.WebRsvDay)) {
          strDayRegis = moment().add(parseInt(data.WebRsvDay, 0), 'day').format('YYYYMMDD');
        }
        // option's age limit
        const otpions = this.dataReservation.objCourse.ListOption ?? [];
        let optionAgeLowLimit = !this.util.isNullOrBlank(this.dataReservation.objCourse.AgeLowLimit) ? parseInt(this.dataReservation.objCourse.AgeLowLimit.trim()) : 0;
        let optionAgeUpLimit = !this.util.isNullOrBlank(this.dataReservation.objCourse.AgeUpLimit) ? parseInt(this.dataReservation.objCourse.AgeUpLimit.trim()) : 1000;

        for (let i = 0; i < otpions.length; i++) {
          otpions[i].AgeLowLimit = !this.util.isNullOrBlank(otpions[i].AgeLowLimit) ? otpions[i].AgeLowLimit.trim() : '0';
          otpions[i].AgeUpLimit = !this.util.isNullOrBlank(otpions[i].AgeUpLimit) ? otpions[i].AgeUpLimit.trim() : '1000';

          if (optionAgeLowLimit < parseInt(otpions[i].AgeLowLimit)) {
              optionAgeLowLimit = parseInt(otpions[i].AgeLowLimit)
          }
          if (optionAgeUpLimit > parseInt(otpions[i].AgeUpLimit)) {
              optionAgeUpLimit = parseInt(otpions[i].AgeUpLimit)
          }
        }

        for (const day of listDate) {
          const date = {
            day: parseInt(day.substring(6, 8), 0),
            month: parseInt(day.substring(4, 6), 0),
            year: parseInt(day.substring(0, 4), 0),
          };
          // Check for course scope
          // 20240918 modify #19712 start
          // if ((!this.util.isNullOrBlank(data.RegStartDate) && !this.util.isNullOrBlank(data.RegEndDate)
          //   && !(data.RegStartDate <= day && data.RegEndDate >= day)) || (day < strDayRegis && !this.util.isNullOrBlank(strDayRegis))) {
          if ((!this.util.isNullOrBlank(data.RegStartDate) && !this.util.isNullOrBlank(data.RegEndDate)
            && !(data.RegStartDate <= day && data.RegEndDate >= day) && data.RegistrationStatus == true) || (day < strDayRegis && !this.util.isNullOrBlank(strDayRegis) && data.RegistrationStatus == true)) {
          // 20240918 modify #19712 end
            const indexFind = this.disabledDates.indexOf(date);
            if (indexFind === -1) {
              // 20230915 modify #19712 start
              //this.disabledDates.push(date);
              const objDate = { date: day, value: 0 };
              this.dateCustomClasses.push(objDate);
              // 20230915 modify #19712 end
            }
          // 20240918 modify #19712 start
          // } else if (!this.util.isNullOrBlank(data.RegStartDate) && data.RegStartDate > day && this.util.isNullOrBlank(data.RegEndDate)) {
          } else if (!this.util.isNullOrBlank(data.RegStartDate) && data.RegStartDate > day && this.util.isNullOrBlank(data.RegEndDate) && data.RegistrationStatus == true) {
          // 20240918 modify #19712 end
            const indexFind = this.disabledDates.indexOf(date);
            if (indexFind === -1) {
              // 20230915 modify #19712 start
              //this.disabledDates.push(date);
              const objDate = { date: day, value: 0 };
              this.dateCustomClasses.push(objDate);
              // 20230915 modify #19712 end
            }
          }

          // Check course's age scope
          if (!this.util.isNullOrBlank(this.objUser.DateOfBirth)) {
            // 20230714 #18739 modify start
            // let bonus = 0;
            // switch (this.dataReservation.objCourse?.AgeCalculateDiv) {
            //   case '2':  // 年度末
            //     bonus = (parseInt(date.year + '' + date.month + '' + date.day) - parseInt(date.year + '0331')) > 0 ? 1 : 0;
            //     break;
            //   case '3': // 年末
            //     bonus = (parseInt(date.year + '' + date.month + '' + date.day) - parseInt(date.year + '0331')) > 0 ? 0 : (-1);
            //     break;
            //   case '4':  // 協会けんぽ
            //     bonus = (parseInt(date.year + '' + date.month + '' + date.day) - parseInt(date.year + '0401')) > 0 ? 1 : 0;
            //     break;
            //   case '1':   // 受診日
            //   default:
            //     break;
            // }
            // const age = moment(day, 'YYYYMMDD').diff(moment(this.objUser.DateOfBirth, 'YYYYMMDD'), 'years') + bonus;
            var paramDate = date.year + '';
            if (date.month < 10) {
              paramDate = paramDate + '0' + date.month;
            }else {
              paramDate = paramDate + date.month;
            }
            if (date.day < 10) {
              paramDate = paramDate + '0' + date.day;
            }else {
              paramDate = paramDate + date.day;
            }
            switch (this.dataReservation.objCourse?.AgeCalculateDiv) {
              case '2':  // 年度末
                paramDate = (parseInt(paramDate) - parseInt(date.year + '0331')) > 0 ? (date.year + 1) + '' + '0331' : date.year + '' + '0331';
                break;
              case '3': // 年末
                paramDate = (parseInt(paramDate) - parseInt(date.year + '0331')) > 0 ? date.year + '' + '1231' : (date.year-1) + '' + '1231';
                break;
              case '4':  // 協会けんぽ
                /* 20241227 #23633 modify start */
                // paramDate = (parseInt(paramDate) - parseInt(date.year + '0401')) > 0 ? (date.year + 1) + '' + '0401' : date.year + '' + '0401';
                /* 20250113 #23633 modify start */
                // paramDate = (parseInt(paramDate) - parseInt(date.year + '0331')) > 0 ? (date.year + 1) + '' + '0331' : date.year + '' + '0331';
                /* 20250213 #23633 modify start */
                // paramDate = (parseInt(paramDate) - parseInt(date.year + '0401')) > 0 ? (date.year + 1) + '' + '0401' : date.year + '' + '0401';
                paramDate = (parseInt(paramDate) - parseInt(date.year + '0401')) >= 0 ? (date.year + 1) + '' + '0401' : date.year + '' + '0401';
                /* 20250213 #23633 modify end */
                /* 20250113 #23633 modify end */
                /* 20241227 #23633 modify end */
                break;
              case '1':   // 受診日
              default:
                break;
            }
            const age = moment(paramDate, 'YYYYMMDD').diff(moment(this.objUser.DateOfBirth, 'YYYYMMDD'), 'years');
            //# 20230714 #18739 modify end
            //20241223 add #19712 start
            const findDateOut = data.ListReservationDate.find(x => x.RsvYMD === day);
            //20241223 add #19712 end
            //20241223 modify #19712 start
            // if (!this.util.isNullOrBlank(this.dataReservation.objCourse.AgeLowLimit) && !this.util.isNullOrBlank(this.dataReservation.objCourse.AgeUpLimit)
            // && (this.dataReservation.objCourse?.AgeLowLimit > age || this.dataReservation.objCourse?.AgeUpLimit < age)) {
            if (!this.util.isNullOrBlank(this.dataReservation.objCourse.AgeLowLimit) && !this.util.isNullOrBlank(this.dataReservation.objCourse.AgeUpLimit)
            && (this.dataReservation.objCourse?.AgeLowLimit > age || this.dataReservation.objCourse?.AgeUpLimit < age) && findDateOut) {
            //20241223 modify #19712 end
              // 20230915 modify #19712 start
              //this.disabledDates.push(date);
              const objDate = { date: day, value: 0 };
              this.dateCustomClasses.push(objDate);
              // 20230915 modify #19712 end
            //20241223 modify #19712 start
            // } else if (this.util.isNullOrBlank(this.dataReservation.objCourse.AgeUpLimit) && !this.util.isNullOrBlank(this.dataReservation.objCourse.AgeLowLimit) && this.dataReservation.objCourse?.AgeLowLimit > age) {
            } else if (this.util.isNullOrBlank(this.dataReservation.objCourse.AgeUpLimit) && !this.util.isNullOrBlank(this.dataReservation.objCourse.AgeLowLimit) && this.dataReservation.objCourse?.AgeLowLimit > age && findDateOut) {
            //20241223 modify #19712 end
              // 20230915 modify #19712 start
              //this.disabledDates.push(date);
              const objDate = { date: day, value: 0 };
              this.dateCustomClasses.push(objDate);
              // 20230915 modify #19712 end
            //20241223 modify #19712 start
            // } else if (this.util.isNullOrBlank(this.dataReservation.objCourse.AgeLowLimit) && !this.util.isNullOrBlank(this.dataReservation.objCourse.AgeUpLimit) && this.dataReservation.objCourse?.AgeUpLimit < age) {
            } else if (this.util.isNullOrBlank(this.dataReservation.objCourse.AgeLowLimit) && !this.util.isNullOrBlank(this.dataReservation.objCourse.AgeUpLimit) && this.dataReservation.objCourse?.AgeUpLimit < age && findDateOut) {
            //20241223 modify #19712 end
              // 20230915 modify #19712 start
              //this.disabledDates.push(date);
              const objDate = { date: day, value: 0 };
              this.dateCustomClasses.push(objDate);
              // 20230915 modify #19712 end
            }

            // Check for option scope
            //20241223 modify #19712 start
            // if (!this.util.isNullOrBlank(optionAgeLowLimit) && !this.util.isNullOrBlank(optionAgeUpLimit)
            // && (optionAgeLowLimit > age || optionAgeUpLimit < age)) {
            if (!this.util.isNullOrBlank(optionAgeLowLimit) && !this.util.isNullOrBlank(optionAgeUpLimit)
            && (optionAgeLowLimit > age || optionAgeUpLimit < age) && findDateOut) {
            //20241223 modify #19712 end
                // 20230915 modify #19712 start
                //this.disabledDates.push(date);
                const objDate = { date: day, value: 0 };
                this.dateCustomClasses.push(objDate);
                // 20230915 modify #19712 end
            }
          }

          const findDate = this.disabledDates.find(x => x.day === date.day && x.month === date.month && x.year === date.year);
          //20240911 modify #19712 start
          // if (!findDate && data.ListReservationDate
          //   && data.ListReservationDate.length > 0) {
          if (!findDate && data.ListReservationDate
            && data.ListReservationDate.length > 0 && data.RegistrationStatus == true) {
          //20240911 modify #19712 end
            const checkDay = data.ListReservationDate.find(x => x.RsvYMD === day);
            // Check booking date is full
            if (checkDay) {
              const objDate = {
                date: day,
                value: checkDay.IsNotFull ? 1 : 0,
              };
              // 20250213 modify #23633 start
              // this.dateCustomClasses.push(objDate);
              const pushData = this.dateCustomClasses.find(x => x.date === day);
              if (!pushData){
                this.dateCustomClasses.push(objDate);
              }
              // 20250213 modify #23633 end
            } else {
              // 20230915 modify #19712 start
              //this.disabledDates.push(date);
              const objDate = { date: day, value: 0 };
              this.dateCustomClasses.push(objDate);
              // 20230915 modify #19712 end
            }
          } else {
            const checkDate = this.dateCustomClasses.find(x => x.date === day);
            //20240911 modify #19712 start
            // if (!checkDate && !findDate) {
            if (!checkDate && !findDate && data.RegistrationStatus == true) {
            //20240911 modify #19712 end
              // 20230915 modify #19712 start
              //this.disabledDates.push(date);
              const objDate = { date: day, value: 0 };
              this.dateCustomClasses.push(objDate);
              // 20230915 modify #19712 end
            }
            //20240911 add #19712 start
            else if(!checkDate && !findDate && data.RegistrationStatus == false){
              this.disabledDates.push(date);
            }
            //20240911 add #19712 end
          }
        }
        if (this.util.isNullOrBlank(data.RegStartDate) && this.util.isNullOrBlank(data.RegEndDate)) {
          this.disabledNext = true;
        } else {
          const strDate = moment(this.startDate).startOf('month').add(1, 'month').format('YYYYMMDD');
          if (!this.util.isNullOrBlank(data.RegEndDate) && data.RegEndDate < strDate) {
            this.disabledNext = true;
          } else {
            this.disabledNext = false;
          }
        }
        setTimeout(() => {
          this.isDisabled = (date: NgbDateStruct, current: { month: number, year: number }) => {
            return this.disabledDates.find(x => NgbDate.from(x).equals(date)) ? true : false || date.month !== current.month;
          };
          this.loadingSrv.setDisplay(false);
        }, 0);
      } else {
        this.loadingSrv.setDisplay(false);
      }
    }, err => {
      this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
      this.loadingSrv.setDisplay(false);
    }, () => {
      const checkDate = this.disabledDates.find(x => x.day === this.RsvDate?.day
        && x.month === this.RsvDate?.month && x.year === this.RsvDate?.year);
      if (!this.util.isNullOrEmpty(this.RsvDate) && isSelect && this.util.isNullOrEmpty(checkDate)) {
        this.selectDate(this.RsvDate, true);
      } else {
        this.objRsvDateTime.RsvYMD = null;
        this.objRsvDateTime.RsvTime = null;
      }
    });
  }
  navigate(numbers: number) {
    const { state, calendar } = this.datepicker;
    this.datepicker.navigateTo(calendar.getNext(state.firstDate, 'm', numbers));
  }
  changeMonthCalendar(value) {
    this.navigate(value);
    // Set start date and end date calendar
    this.startDate = moment(this.startDate).add(value, 'month').startOf('month').toDate();
    this.endDate = moment(this.endDate).add(value, 'month').endOf('month').toDate();
    if (value === 1) {
      this.disabledPrev = false;
    } else {
      if (moment(this.startDate).format('YYYYMMDD') <= moment().format('YYYYMMDD')) {
        this.disabledPrev = true;
        this.startDate = new Date();
        this.minDate = this.calendar.getToday();
      }
    }
    this.RsvDate = null;
    this.objRsvDateTime.RsvYMD = null;
    this.objRsvDateTime.RsvTime = null;
    this.listReservationSelect = [];
    this.getReservationStatus();
  }
  // 20250113 modify #23633 start
  // getDay(date, type) {
  //   const day = date.year.toString() + (date.month > 9 ? date.month.toString() : '0' + date.month.toString())
  //     + (date.day > 9 ? date.day.toString() : '0' + date.day.toString());
  //   const findDate = this.dateCustomClasses.find(x => x.date === day);
  //   if (findDate) {
  //     if (findDate.value === type) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return false;
  //   }
  // }
  getDay(date, type) {
    const day = date.year.toString() + (date.month > 9 ? date.month.toString() : '0' + date.month.toString())
      + (date.day > 9 ? date.day.toString() : '0' + date.day.toString());
    if (this.dateCustomClasses.length > 40) {
      const findDate = this.dateCustomClasses.find(x => x.date === day);     
      if (findDate) {
        if (findDate.value === type) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }  
    else {
      const xData = JSON.parse(JSON.stringify(this.dateCustomClasses));
      const findDate = xData.reverse().find(x => x.date === day);   
      if (findDate) {
        if (findDate.value === type) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }
  // 20250113 modify #23633 end
  selectDate(date: NgbDate, chooseItem = false) {
    this.loadingSrv.setDisplay(true);
    const day = date.year + '/' + date.month + '/' + date.day;
    this.objRsvDateTime.RsvYMD = moment(day).format('YYYYMMDD');
    const objSearch = {
      RsvYMD: this.objRsvDateTime.RsvYMD,
      HTOrgCode: this.HTOrgCode,
      RsvGender: this.objUser.Gender,
      HTCourseCode: this.dataReservation.objCourse?.HTCourseCode,
      CoCode: this.dataReservation.objCourse?.CoCode,
      HTSetItemCode: this.getListHTSetItemCode(),
      /* 20250319 #24407 add start */
      RsvNum: this.objUser.RsvNum,
      EditDateFlag: this.objRsvDateTime.RsvYMD == this.objUser.RsvDate,
      /* 20250319 #24407 add end */
    };
    this.reservationDateSelService.searchReservationStatusByDay(objSearch).subscribe(data => {
      if (data) {
        for (const item of data){
          item.RsvGender = item.RsvGender?.trim() ? item.RsvGender : '3';
        }
      }
      this.listReservationSelect = [];
      if (data && data.length > 0) {
        this.listReservationSelect = data;
      }
      this.loadingSrv.setDisplay(false);
    }, err => {
      this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
      this.loadingSrv.setDisplay(false);
    }, () => {
      if (chooseItem) {
        const findTime = this.listReservationSelect.find(x => x.RsvTime === this.objRsvDateTime.RsvTime);
        if (!this.util.isNullOrEmpty(findTime) && !this.getDisabledItem(findTime)) {
          findTime.Checked = true;
        }
      } else {
        this.objRsvDateTime.RsvTime = null;
      }
    });
  }
  ButtonBack() {
    if (this.typeMode === 3 ||this.typeMode === 2) {
      const dataLocalOld = sessionStorage.getItem('DataReservationOld');
      /*20240724 modify #21672 start */
      const changeDate = sessionStorage.getItem('ChangeDate');
      if (!this.util.isNullOrEmpty(dataLocalOld)) {
        if(!this.util.isNullOrEmpty(changeDate)){
          const changeDateNew = JSON.parse(changeDate);
          this.dataReservation.objRsvDateTime = changeDateNew;
        }else{
          const dataOld = JSON.parse(dataLocalOld);
          this.dataReservation.objRsvDateTime = dataOld.objRsvDateTime;
        }
        /*20240724 modify #21672 end */
        sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
      }
      if (this.isBack0305) {
        this.isRedirecting = true;
        this.router.navigate(['exam-course-sel'], {
          queryParams: {
            mode: ScreenMode.Edit, date: this.RsvDateParam, num: this.RsvNumParam, htorgcode: this.HTOrgCode
          }
        });
      } else {
        this.isRedirecting = true;
        if(this.typeMode === 3) {
          this.router.navigate(['reservation-detail'], {
            queryParams: {
              mode: ScreenMode.Edit, date: this.RsvDateParam, num: this.RsvNumParam, htorgcode: this.HTOrgCode
            }
          });
        } else {
          this.router.navigateByUrl('reservation-detail');
        }
      }
    } else {
      this.isRedirecting = true;
      this.router.navigateByUrl('exam-course-sel');
    }
  }
  ButtonNext() {
    this.isRedirecting = true;
    this.dataReservation.objRsvDateTime = this.objRsvDateTime;
    sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
    this.router.navigateByUrl('reservation-detail');
  }
  ButtonEdit() {
    this.isRedirecting = true;
    this.dataReservation.objRsvDateTime = this.objRsvDateTime;
    /*20240724 add #21672 start */
    sessionStorage.setItem('ChangeDate', JSON.stringify(this.objRsvDateTime));
    /*20240724 add #21672 end */
    sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
    if (this.typeMode === 2) {
      this.router.navigateByUrl('reservation-detail');
    } else if (this.typeMode === 3) {
      this.router.navigate(['reservation-detail'], {
        queryParams: {
          mode: ScreenMode.Edit, date: this.RsvDateParam, num: this.RsvNumParam, htorgcode: this.HTOrgCode
        }
      });
    }
  }
  checkDisableNext() {
    if (!this.util.isNullOrEmpty(this.objRsvDateTime.RsvYMD) && !this.util.isNullOrEmpty(this.objRsvDateTime.RsvTime)) {
      return false;
    } else {
      return true;
    }
  }
  changeSelectTime(item: any) {
    this.listReservationSelect.map(a => a.Checked = false);
    item.Checked = true;
    this.objRsvDateTime.RsvTime = item.RsvTime;
  }
  getSelectedDate(date: NgbDate) {
    const day = date.year + '/' + date.month + '/' + date.day;
    const dateSelect = moment(day).format('YYYYMMDD');
    if (this.objRsvDateTime.RsvYMD && dateSelect === this.objRsvDateTime.RsvYMD) {
      return true;
    } else {
      return false;
    }
  }
  getListHTSetItemCode() {
    const lstItemCode = [];
    this.dataReservation.objCourse?.ListOption?.forEach(element => {
      lstItemCode.push(element.HTSetItemCode);
    });
    return lstItemCode;
  }

  // /*20240522 add #21672 start */
  // stringToBoolean(str) {
  //   return str === "true";
  // }
  // /*20240522 add #21672 end */

  getDisabledItem(item) {
    // /*20240412 add #21672 start */
    // if((item.ListExaminationFrame == null || item.ListExaminationFrame.length < 1) && (this.lstExaminationFrame == null || this.lstExaminationFrame.length < 1) 
    //   && this.dataReservation.objRsvDateTimeOld.RsvYMD == item.RsvYMD && this.dataReservation.objRsvDateTimeOld.RsvTime == item.RsvTime){
    //   return false;
    // }
    // if (item.ListExaminationFrame && item.ListExaminationFrame.length > 0) {
    //   for (const iterator of item.ListExaminationFrame) {
    //     const rsvConsumptionFrame = iterator?.RsvConsumptionFrame ? parseInt(iterator?.RsvConsumptionFrame, 0) : 0;
    //     const rsvUpperLimitFrame = iterator?.RsvUpperLimitFrame ? parseInt(iterator?.RsvUpperLimitFrame, 0) : 0;
    //     if(iterator?.ExaminationFrameCode == null && (this.lstExaminationFrame == null || this.lstExaminationFrame.length < 1) 
    //       && this.dataReservation.objRsvDateTimeOld 
    //       && this.dataReservation.objRsvDateTimeOld.RsvYMD == item.RsvYMD && this.dataReservation.objRsvDateTimeOld.RsvTime == item.RsvTime ){
    //       return false; 
    //     }
    //     if(rsvConsumptionFrame >= rsvUpperLimitFrame){
    //       if (this.dataReservation.objRsvDateTimeOld && this.dataReservation.objRsvDateTimeOld.RsvYMD == item.RsvYMD && this.dataReservation.objRsvDateTimeOld.RsvTime == item.RsvTime
    //         /*20240522 modify #21672 start */
    //         // && this.lstExaminationFrame?.some((res) => res?.ExaminationFrameCode === iterator?.ExaminationFrameCode) && this.isClick == false) {
    //         /*20240523 modify #21672 start */
    //         // && this.lstExaminationFrame?.some((res) => res?.ExaminationFrameCode === iterator?.ExaminationFrameCode) && this.stringToBoolean(this.isClick) == false)
    //         && this.lstExaminationFrame?.some((res) => res?.ExaminationFrameCode === iterator?.ExaminationFrameCode)) {
    //           let listOptionOld = this.dataReservation.objRsvDateTimeOld.ListOption;
    //           let listOptionNew = this.dataReservation.objCourse.ListOption;
    //           if(listOptionOld && listOptionNew){
    //             for(const iteratorNew of listOptionNew){
    //               for(const iteratorOld of listOptionOld){
    //                   if(iteratorNew.HTSetItemCode == iteratorOld.HTSetItemCode){
    //                     return false;
    //                   }
    //               }
    //             }
    //           }
    //         /*20240523 modify #21672 end */
    //         /*20240522 modify #21672 end */
    //       }
    //     }
    //   }
    // }
    // /*20240412 add #21672 end */

    // 20230915 add #19712 start 
    const checkDate = this.dateCustomClasses.find(x => x.date === item.RsvYMD);
    if(checkDate?.value == 0){
      return true;
    }
    // 20230915 add #19712 end
    // BUG-0403
    /* 20240828 #21996 add start */
    if(this.util.isNullOrBlank(item.AllCourseUpperLimitFrame) || item.AllCourseUpperLimitFrame == 0 ) return true;
    /* 20240828 #21996 add end */
    if(this.dataReservation.objCourse.HTCourseDiv === '1' && (this.util.isNullOrBlank(item.HTUpperLimitFrame) || item.HTUpperLimitFrame == 0 )) return true;
    if(this.dataReservation.objCourse.HTCourseDiv === '2' && (this.util.isNullOrBlank(item.MedicalCheckupUpperlimitframe) || item.MedicalCheckupUpperlimitframe == 0 )) return true;

    if (!this.util.isNullOrEmpty(item.RsvGender) && !this.util.isNullOrEmpty(this.objUser.Gender)
      && item.RsvGender !== this.objUser.Gender && item.RsvGender !== '3' && this.objUser.Gender !== '3') {
      return true;
    }
    const strAge = this.util.calculateAge2(this.util.stringToDate(this.objUser.DateOfBirth),
      this.dataReservation.objCourse.AgeCalculateDiv, this.objRsvDateTime.RsvYMD);
    const intAge = (parseInt(strAge, 0) % 2);
    const strOddEvenAgeDiv = intAge === 0 ? '1' : '2';
    if (item.OddEvenAgeDiv && strOddEvenAgeDiv && item.OddEvenAgeDiv !== '3'
      && item.OddEvenAgeDiv !== strOddEvenAgeDiv) {
      return true;
    }
    if (parseInt(item.AllCourseConsumptionFrame, 0) >= parseInt(item.AllCourseUpperLimitFrame, 0)) {
      return true;
    }
    if (this.dataReservation.objCourse.HTCourseDiv) {
      if ((this.dataReservation.objCourse.HTCourseDiv === '1')
        && parseInt(item.HTConsumptionFrame, 0) >= parseInt(item.HTUpperLimitFrame, 0)) {
        return true;
      } else if (this.dataReservation.objCourse.HTCourseDiv === '2'
        && parseInt(item.MedicalCheckupConsumptionFrame, 0) >= parseInt(item.MedicalCheckupUpperlimitframe, 0)) {
        return true;
      }
    }
    if (item.ListExaminationFrame && item.ListExaminationFrame.length > 0) {
      if(this.lstExaminationFrame?.some((res) => item.ListExaminationFrame.every(frame => frame.ExaminationFrameCode != res?.ExaminationFrameCode))){
        return true;
      }
      for (const iterator of item.ListExaminationFrame) {
        const rsvConsumptionFrame = iterator?.RsvConsumptionFrame ? parseInt(iterator?.RsvConsumptionFrame, 0) : 0;
        const rsvUpperLimitFrame = iterator?.RsvUpperLimitFrame ? parseInt(iterator?.RsvUpperLimitFrame, 0) : 0;
        if (rsvConsumptionFrame >= rsvUpperLimitFrame) {
          if((iterator?.ExaminationFrameCode == null && iterator?.RsvUpperLimitFrame != null) || (iterator?.ExaminationFrameCode != null && iterator?.RsvUpperLimitFrame == null)) return true;
          if(this.lstExaminationFrame?.some((res) => res?.ExaminationFrameCode === iterator?.ExaminationFrameCode)) return true;
        }
      }
    }
  }
  checkChangeData() {
    const dataLocalOld = sessionStorage.getItem('DataReservation');
    const dataOld = JSON.parse(dataLocalOld);
    /* 20250319 #24407 modify start */
    // if (!this.util.isNullOrEmpty(dataOld) && JSON.stringify(this.objRsvDateTime) !== JSON.stringify(dataOld.objRsvDateTime)) {
    if (!this.util.isNullOrEmpty(dataOld)) {
    /* 20250319 #24407 modify end */
      return true;
    } else {
      return false;
    }
  }

  // Show poup when change data
  setDeactivateState(nextState) {
    if (this.isRedirecting) {
      this.isRedirect = true;
    }
    else {
      const checkChange = this.checkDataChangeRedirect();
      if (checkChange || this.typeMode === 1 || this.typeMode === 2) {
        /*20240311 #21672 modify start*/
        /*const message = this.trans.instant('MESS_CNF_CHANGESCREEN_WITHOUT_REGIS');
        this.dialogModalService.openConfirmModal(message).subscribe((res: DialogResult) => {
          if (res.isOk()) {
            this.isRedirect = true;
            this.isRedirecting = true;
            this.setHTOrgName('');
            this.removeDataToSession();
            this.router.navigate([nextState]);
          }
        });*/
        const message = this.trans.instant('MESS_CNF_CHANGESCREEN_WITHOUT_REGIS');
        if (nextState == '/404') {
          
        }else {
          this.dialogModalService.openConfirmModal(message).subscribe((res: DialogResult) => {
            if (res.isOk()) {
              this.isRedirect = true;
              this.isRedirecting = true;
              this.setHTOrgName('');
              this.removeDataToSession();
              this.router.navigate([nextState]);
            }
          });
        }
        /*20240311 #21672 modify end*/
      } else {
        this.isRedirect = true;
      }
    }
  }
  // Show poup when change data
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.isRedirect;
  }
  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    if (this.checkDataChangeRedirect() || this.typeMode === 1 || this.typeMode === 2) {
      return false;
    } else {
      return true;
    }
  }
  setHTOrgName(pHTOrgName) {
    const objHTOrg = {
      HTOrgCode: null,
      HTOrgName: pHTOrgName,
    };
    this.store.dispatch(new GetIMstHTOrg(objHTOrg));
  }
  removeDataToSession() {
    sessionStorage.removeItem('HTOrgCode');
    sessionStorage.removeItem('DataReservation');
    sessionStorage.removeItem('DataReservationOld');
  }
  checkDataChangeRedirect() {
    const dataLocal = sessionStorage.getItem('DataReservation');
    const dataLocalOld = sessionStorage.getItem('DataReservationOld');
    if (!this.util.isNullOrBlank(dataLocal) && !this.util.isNullOrBlank(dataLocalOld) && (dataLocal !== dataLocalOld
     || JSON.stringify(this.objRsvDateTime) !== JSON.stringify(JSON.parse(dataLocalOld).objRsvDateTime))) {
      return true;
    } else {
      return false;
    }
  }

  private checkOptionOddOrEven() {
    const checkDisableAll = this.dataReservation?.objCourse?.ListOption?.some((res) => res?.OddEvenAgeDiv === OddEvenAgeDiv.Odd || res?.OddEvenAgeDiv === OddEvenAgeDiv.Even);
    this.disableAllDay = false
    if(checkDisableAll !== undefined && checkDisableAll)
    {
      if(this.dataReservation.objCourse.ListOption.length > 0)
      {
        const getEvenAgeDiv = this.dataReservation.objCourse.ListOption.filter((res) => res.OddEvenAgeDiv === '1')
        const getOddAgeDiv = this.dataReservation.objCourse.ListOption.filter((res) => res.OddEvenAgeDiv === '2')
        if( getEvenAgeDiv.length > 0 && getOddAgeDiv.length > 0) {
            this.disableDayOddOrEven = OddEvenAgeDiv.Both
            this.disableAllDay = true
             } else {
              if(getEvenAgeDiv.length > 0) {
                this.disableDayOddOrEven = OddEvenAgeDiv.Even
                } else {
                this.disableDayOddOrEven = OddEvenAgeDiv.Odd
              }
            }
        } else {
        this.disableDayOddOrEven = OddEvenAgeDiv.Both
      }
    } else {
        this.disableDayOddOrEven = OddEvenAgeDiv.Both
    }
  }
  private preventButtonBackBrowser() {
    history.pushState(null,"", window.location.href);
  }
  private ageCalculateByTypeOne(birdDay: string,typeDiv: string,currentDay: string) {
    const currenD = new Date(Number(parseInt((currentDay.substring(0, 4)))), Number(currentDay.substring(4, 6))-1, Number(currentDay.substring(6)));
    const birdD = new Date(Number(parseInt((birdDay.substring(0, 4)))), Number(birdDay.substring(4, 6))-1, Number(birdDay.substring(6)));
    return this.util.calculateAgeTypOne(birdD,typeDiv,currentDay); //69
  }
  /* 20231006 add #19525 start */ 
  async deleteConcurrent() {
    const pConcurrent = {
      KeyDate: this.RsvDateParam,
      KeyNum: this.RsvNumParam,
      HtOrgCode: this.HTOrgCode,
      ScreenDiv: '0'
    };
    await this.common.DeleteConcurent(pConcurrent).toPromise();
  }

  @HostListener('window:unload', ['$event'])
  unload(event: Event) {
    this.deleteConcurrent();
  }

  ngOnDestroy(): void {
    this.deleteConcurrent();
  }
  /* 20231006 add #19525 end */  
}

export enum OddEvenAgeDiv {
   Odd = "1" ,
   Even = "2" ,
   Both = "3"
}
